exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.grade-setting-row {\n  border: 1px solid #eaeefb;\n}\n.grade-setting-col {\n  height: 100%;\n  padding: 18px 20px;\n}\n.grade-setting-item {\n    padding-bottom: 10px;\n}\n.title {\n  font-weight: bold;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-78d6fefd","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/popularize/promoterSetting.vue
// module id = 1601
// module chunks = 0